import { LocationOnIcon } from '@ui/icons/material/LocationOn';
import { PhoneIcon } from '@ui/icons/material/Phone';
import { EmailIcon } from '@ui/icons/material/Email';
import '../styles/footer.css';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      {/* Top Divider */}
      <div className="footer-divider"></div>

      <div className="footer-content">
        <div className="container">
          {/* Logo Section */}
          <div className="footer-header">
            <div className="footer-logo-section">
              <img src="/images/ctump/logo.gif" alt="CTUMP Logo" className="footer-logo" />
              <div className="footer-brand">
                <h3>Trường Đại học Y Dược Cần Thơ</h3>
                <p>Đơn vị đào tạo hàng đầu về y dược tại khu vực Tây Nam Bộ</p>
              </div>
            </div>
          </div>

          {/* Main Content Grid */}
          <div className="footer-grid">
            <div className="footer-section">
              <h4>Liên kết nhanh</h4>
              <ul className="footer-links">
                <li><a href="#mission">Sứ mạng</a></li>
                <li><a href="#timeline">Lịch sử</a></li>
                {/*<li><a href="#education">Đào tạo</a></li>*/}
                <li><a href="#research">Nghiên cứu</a></li>
                <li><a href="#contact">Liên hệ</a></li>
              </ul>
            </div>

            <div className="footer-section">
              <h4>Thông tin</h4>
              <ul className="footer-links">
                <li><a href="https://www.ctump.edu.vn/" target="_blank">Về trường</a></li>
                <li><a href="https://www.ctump.edu.vn/" target="_blank">Tuyển sinh</a></li>
                <li><a href="https://www.ctump.edu.vn/" target="_blank">Thư viện</a></li>
                <li><a href="https://www.ctump.edu.vn/" target="_blank">Hỗ trợ sinh viên</a></li>
                <li><a href="https://www.ctump.edu.vn/" target="_blank">Danh bạ liên lạc</a></li>
              </ul>
            </div>

            <div className="footer-section">
              <h4>Liên hệ</h4>
              <ul className="footer-links">
                <li className="contact-item">
                  <LocationOnIcon className="footer-icon" />
                  <span>Số 179, đường Nguyễn Văn Cừ, P. Tân An, TP. Cần Thơ</span>
                </li>
                <li className="contact-item">
                  <PhoneIcon className="footer-icon" />
                  <a href="tel:02923739730">(84-0292) 3 739 730</a>
                </li>
                <li className="contact-item">
                  <EmailIcon className="footer-icon" />
                  <a href="mailto:ctump@ctump.edu.vn">ctump@ctump.edu.vn</a>
                </li>
              </ul>
            </div>

            <div className="footer-section">
              <h4>Kết nối với chúng tôi</h4>
              <ul className="footer-links social-links">
                <li><a href="https://www.facebook.com/dhydct.ctump.edu.vn/" className="social-icon facebook" title="Facebook">f</a></li>
                <li><a href="https://www.tiktok.com/@ctump.edu.vn?is_from_webapp=1&sender_device=pc" className="social-icon linkedin" title="TikTok">T</a></li>
                <li><a href="https://www.youtube.com/truongdaihocyduocct" className="social-icon youtube" title="YouTube">▶</a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <div className="container">
          <div className="footer-bottom-content">
            <p>&copy; {currentYear} Trường Đại học Y Dược Cần Thơ. Bảo lưu mọi quyền.</p>
            <ul className="footer-legal">
              <li><a href="https://www.ctump.edu.vn/">Chính sách bảo mật</a></li>
              <li><a href="https://www.ctump.edu.vn/">Điều khoản sử dụng</a></li>
              <li><a href="https://www.ctump.edu.vn/">Liên hệ</a></li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
}